export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/whiteboard_animated_explainers.7a2f90e.svg";